import axios from 'axios';

const reqUrl = process.env.NEXT_PUBLIC_RELEVANCE_RTAG_API_URL;

async function createRtag({
  objective,
  region,
  spo,
  audience,
}: {
  objective: string;
  region: string;
  spo: string;
  audience: string;
}) {
  const { data } = await axios.post(`${reqUrl}/trigger_limited_async`, {
    params: {
      po: objective,
      region: region,
      spo1: spo,
      ta: audience,
    },
    project: '8f8205497a61-4568-b3f2-c46fb2b0bdef',
    studio_id: '1d763819-7216-4491-8e64-e51c38835487',
  });
  return data;
}

async function getRtag({ jobId }: { jobId: string }) {
  const params = {
    ending_update_only: false,
    project: '8f8205497a61-4568-b3f2-c46fb2b0bdef',
    sort: '[{"message_id":"desc"}]',
  };
  const { data } = await axios.get(`${reqUrl}/async_poll/${jobId}`, { params });
  return data;
}

export const rtags = {
  createRtag,
  getRtag,
};
